import { useEffect, useState } from 'react'
import type { GapAnalysisFilters } from '../API/rtk-query-api/store/tmsApi'
import { useAppSelector } from '../redux/hooks'

const useFormattedFilters = () => {
  const [currentFilters, setCurrentFilters] = useState<GapAnalysisFilters>({
    competencies: [],
    hierarchies: [],
    managerIds: [],
    matchOption: 'MATCH_ANY',
    occupations: [],
    people: [],
    showAllReports: false
  })

  const gapAnalysisFilters = useAppSelector(state => state.gapAnalysisFilters)

  useEffect(() => {
    setCurrentFilters({
      competencies: gapAnalysisFilters.selectedCompetencies.map(c => {
        return { id: c.value, name: c.text }
      }),
      hierarchies: gapAnalysisFilters.selectedHierarchies,
      managerIds: gapAnalysisFilters.selectedManagers.map(m => m.value),
      matchOption: gapAnalysisFilters.hierarchyViewMode.value === 'any' ? 'MATCH_ANY' : 'MATCH_ALL',
      occupations: gapAnalysisFilters.selectedOccupations.map(o => o.text),
      people: gapAnalysisFilters.selectedPeople.map(p => {
        return { id: p.value, fullName: p.text }
      }),
      showAllReports: gapAnalysisFilters.showAllReports
    })
  }, [
    gapAnalysisFilters.selectedCompetencies,
    gapAnalysisFilters.selectedHierarchies,
    gapAnalysisFilters.selectedManagers,
    gapAnalysisFilters.hierarchyViewMode,
    gapAnalysisFilters.selectedOccupations,
    gapAnalysisFilters.selectedPeople,
    gapAnalysisFilters.showAllReports
  ])

  return currentFilters
}

export default useFormattedFilters
